/* eslint-disable @typescript-eslint/no-explicit-any */
import { ToolbarProps, HeaderProps } from "react-big-calendar";
import { Toolbar } from "./Toolbar";
import WeekHeader from "./WeekHeader";
import SlotComponent from "./slotComponent";
import { isSameDay } from "date-fns";
import { Slot } from "core/types/index";
import { IcbtCommunication } from "api/types";
import { memo } from "react";

/** Stop flickering or dismissing of subcomponents (e.g. Templates Modal) when updating slots */
const MemoizedToolbar = memo((props: ToolbarProps) => <Toolbar {...props} />);
MemoizedToolbar.displayName = "MemoizedToolbar";

export const customCalendarComponents = (extraProps: {
  slots: Slot[];
  icbtCommunication: IcbtCommunication[];
  icbtCommunicationFeaturesEnabled: boolean;
}) => ({
  toolbar: MemoizedToolbar,
  week: {
    header: (props: HeaderProps) => {
      const { date } = props;
      const { slots, icbtCommunication, icbtCommunicationFeaturesEnabled } =
        extraProps;

      const slotsOfDay =
        slots.filter(
          (slot: Slot) =>
            slot.method === "VIDEO" &&
            isSameDay(new Date(slot.startsAt * 1_000), date),
        ) ?? [];
      const feedbacksOfDay =
        icbtCommunication?.filter(({ feedback_date }) => {
          return isSameDay(new Date(feedback_date), date);
        }) ?? [];

      return (
        <WeekHeader
          {...{
            ...props,
            slots: slotsOfDay,
            feedbacks: feedbacksOfDay,
            icbtCommunicationFeaturesEnabled,
          }}
        />
      );
    },
  },
  event: ({ event }: any) => <SlotComponent event={event} />,
});
